module.exports = __webpack_public_path__ + "static/media/fundo-onda-revo.99778d48.svg";